import { createApp } from 'vue';
import App from './App.vue';

export function mountSoilTest() {
	const el = document.getElementById('soil-testing-app');
	if (!el) return;

	createApp(App, {
		csrfToken: el.dataset.csrfToken,
		csrfParam: el.dataset.csrfParam
	}).mount(el);
}
